import classNames from "classnames/bind";
import Button from "common/blocks/Button";
import DynamicPhoneNumber from "common/blocks/DynamicPhoneNumber";
import Image from "common/blocks/Image";
import UIIcon from "common/blocks/UIIcon";
import formatCurrency from "utils/formatCurrency";

import styles from "./SavingsPriceSidePanel.module.scss";

const cx = classNames.bind(styles);

export type SavingsPriceSidePanelProps = {
    summary: string;
    comparisonPriceLabel: string;
    comparisonPrice: number;
    salePriceLabel: string;
    salePrice: number;
    savingsLabel: string;
    savings: number;
    enquiryLink: string;
    reserveLink?: string;
    isComingSoon?: boolean;
};

const SavingsPriceSidePanel = (props: SavingsPriceSidePanelProps) => {
    const {
        summary,
        comparisonPrice,
        salePrice,
        savings,
        comparisonPriceLabel,
        salePriceLabel,
        savingsLabel,
        enquiryLink,
        reserveLink,
        isComingSoon,
    } = props;

    return (
        <>
            <div className={cx("contentContainer")}>
                <span
                    className={cx("summaryWrapper")}
                    dangerouslySetInnerHTML={{
                        __html: summary,
                    }}
                />
                <div className={cx("priceComparisonContainer")}>
                    <div className={cx("priceComparisonBody")}>
                        <div className={cx("background")}>
                            <div className={cx("comparisonContainer", "container")}>
                                <div className={cx("infoContainer", "comparison")}>
                                    <UIIcon
                                        svgProps={{ className: cx("icon") }}
                                        icon="PriceTag"
                                    ></UIIcon>
                                    <div className={cx("textContainer")}>
                                        <span className={cx("heading")}>
                                            {comparisonPriceLabel}
                                        </span>
                                        <span
                                            className={cx("value")}
                                            dangerouslySetInnerHTML={{
                                                __html: formatCurrency(comparisonPrice, 0),
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={cx("salePriceContainer", "container")}>
                                <div className={cx("infoContainer")}>
                                    <UIIcon
                                        svgProps={{ className: cx("icon") }}
                                        icon="MotorpointCircleLogo"
                                    ></UIIcon>
                                    <div className={cx("textContainer")}>
                                        <span className={cx("heading")}>{salePriceLabel}</span>
                                        <span
                                            className={cx("value")}
                                            dangerouslySetInnerHTML={{
                                                __html: formatCurrency(salePrice, 0),
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={cx("savingsPriceContainer", "container")}>
                                <div className={cx("infoContainer")}>
                                    <UIIcon
                                        svgProps={{ className: cx("icon") }}
                                        icon="SaveCalculator"
                                    ></UIIcon>

                                    <div className={cx("textContainer")}>
                                        <span className={cx("heading")}>{savingsLabel}</span>
                                        <span
                                            className={cx("value")}
                                            dangerouslySetInnerHTML={{
                                                __html: formatCurrency(savings, 0),
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={cx("buttonWrapper")}>
                    {!isComingSoon && (
                        <Button
                            href={reserveLink}
                            fullWidth
                            theme="primary"
                            type="button"
                            ariaLabel="Reserve or Buy"
                            rel="nofollow"
                        >
                            Reserve or Buy
                        </Button>
                    )}
                    {isComingSoon && (
                        <div className={cx("savings-banner-cta-container")} id="call-us-now-cta">
                            <Button
                                fullWidth
                                theme="primary"
                                type="button"
                                ariaLabel="Call us to reserve"
                                className={cx("reserve")}
                            >
                                <DynamicPhoneNumber
                                    isLink
                                    prefix="Call us to reserve"
                                    iconName="PhoneEmpty"
                                    showNumber={false}
                                />
                            </Button>
                        </div>
                    )}
                    <Button
                        href={enquiryLink}
                        target="_blank"
                        theme="secondary"
                        fullWidth
                        className={cx("buttonSecondary", "button")}
                        ariaLabel="Make enquiry"
                    >
                        <UIIcon icon="Mail" className={cx("mailIcon")} /> Enquire
                    </Button>
                </div>
            </div>
        </>
    );
};

export default SavingsPriceSidePanel;
